import React from 'react'
import { Card, PageTitle } from '../components/Ui'

export default function PlaceholderPage({ title, eyebrow = 'ADMIN MODULE', description = '1차 관리자 IA에는 포함되어 있으며, 핵심 거래 화면 검수 후 상세 퍼블리싱합니다.' }) {
  return <><PageTitle eyebrow={eyebrow} title={title} description={description} /><Card><div className="placeholder-state"><span>WORKFLOW READY</span><h2>{title}</h2><p>DB v0.1에 필요한 도메인과 권한은 반영되어 있습니다. 화면 구성은 핵심 관리자 플로우 검수 결과를 반영해 확장합니다.</p><div><strong>API DTO 우선 설계</strong><strong>RBAC 적용 예정</strong><strong>Audit Log 연동 예정</strong></div></div></Card></>
}
